import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ValueValidator } from '../validator/fieldValueValidator';
import { WidgetnameValidator } from '../validator/widgetname_asyncValidator';
import { WidgetbuilderService } from './widgetbuilder.service';
import * as echarts from "echarts";
import { SharedService } from 'src/app/services/shared.service';
import { UserLoginService } from 'src/app/user-login/user-login.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


interface PanelState {
  isExpanded: boolean;
}

interface StepTab {
  label: string;
  step: number;
  isActive: boolean;
  enable:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WidgetBuilderVarService {

  constructor(
    private userloginservice: UserLoginService,
    private sharedService: SharedService,
    private widgetbuilderservice: WidgetbuilderService
  ) { }

  inputData={"title":"","subtitle":null,"type":"","widgetdata":{},"style":{}}

  testImage='assets/widgets/empty-data.svg'


  titles={
    "save":"SAVE",
    "run":"RUN",
    "cancel":"CANCEL",
    "chart":"Chart",
    "data_table":"Data Table",
    "not":"NOT",
    "logical_not":"!",
    "and":"and",
    "invalid_time":"Invalid time",
    "apply":"APPLY"
  }

  colorPalette =[
    [
      "#a6d4e7",
      "#e0eff6",
      "#b8c4cc",
      "#5fb3d9",
      "#0081b8",
      "#737373",
      "#454545",
      "#9e57bc",
      "#6c2f8f"
    ],
    [
      "#0092d1",
      "#c3e1ef",
      "#7fd0f0",
      "#0092d1",
      "#00567a",
      "#0079ad",
      "#f8c4b4",
      "#f28b6b",
      "#f55524",
    ],
    [
      "#b5b5b5",
      "#ffffff",
      "#999999",
      "#95f542",
      "#73dc1e",
      "#4b970c",
      "#0092d1",
      "#0070a3",
      "#00567a"
    ],
    [
      "#4b970c",
      "#ff8a5c",
      "#f55524",
      "#a6a6a6",
      "#FFB38F",
      "#7ee02f",
      "#dedede",
      "#68c71a",
      "#454545"
    ],
    [
      "#d0648a",
      "#57a79c",
      "#f58db2",
      "#f2b3c9",
      "#22c3aa",
      "#7bd9a5",
      "#8a39ac",
      "#b56cd1",
      "#56007a",
    ],
    [
      "#ff8b68",
      "#fff9eb",
      "#999999",
      "#b86fd3",
      "#56007a",
      "#6d1694",
      "#8a39ac",
      "#f8ad96",
      "#8f1500"
      // "#f55524",
    ],
    [
      "#61C2A2",
      "#4C7D60",
      "#2C8395",
      "#384960",
      "#A9BCB0",
      "#E88670",
      "#7fd6b8",
      "#3da9b8",
      "#5c6f87",
    ],
    [
      "#e8d7d5",
      "#f5f1f0",
      "#5C97B8",
      "#183A53",
      "#DCDBD8",
      "#2c536d",
      "#D1A58A",
      "#7ab0cf",
      "#715B5B"
    ]
  ]

  filterOperators=[
    {
      "disp": "!=",
      "value": [
        "!=",
        [
          0,
          1,
          2,
          3
        ]
      ]
    },
    {
      "disp": "<",
      "value": [
        "<",
        [
          0
        ]
      ]
    },
    {
      "disp": "=",
      "value": [
        "=",
        [
          0,
          1,
          2,
          3
        ]
      ]
    },
    {
      "disp": ">",
      "value": [
        ">",
        [
          0
        ]
      ]
    },
    {
      "disp": "CONTAINS",
      "value": [
        "CONTAINS",
        [
          2
        ]
      ]
    },
    {
      "disp": "NOT CONTAINS",
      "value": [
        "NOT CONTAINS",
        [
          2
        ]
      ]
    },
    {
      "disp": "ENDSWITH",
      "value": [
        "ENDSWITH",
        [
          2
        ]
      ]
    },
    {
      "disp": "NOT ENDSWITH",
      "value": [
        "NOT ENDSWITH",
        [
          2
        ]
      ]
    },
    {
      "disp": "IN",
      "value": [
        "IN",
        [
          0,
          1,
          2,
          3
        ]
      ]
    },
    {
      "disp": "NOT IN",
      "value": [
        "NOT IN",
        [
          0,
          1,
          2,
          3
        ]
      ]
    },
    {
      "disp": "STARTSWITH",
      "value": [
        "STARTSWITH",
        [
          2
        ]
      ]
    },
    {
      "disp": "NOT STARTSWITH",
      "value": [
        "NOT STARTSWITH",
        [
          2
        ]
      ]
    }
  ]
   dataSetType=[]

  // dataSetType=[
  //   {
  //     "disp":"Event logs",
  //     "value":"event_logs",
  //     "status":1
  //   },
  //   {
  //     "disp":"Alerts & Ticketing",
  //     "value":"alert_ticketing",
  //     "status":1
  //   },
  //   {
  //     "disp":"Threat intel",
  //     "value":"threat_entity",
  //     "status":1
  //   },
  //   {
  //     "disp":"Blended",
  //     "value":"blended",
  //     "status":1
  //   }
    
  // ]

  widgetType = new FormControl()

  selectedWidget=''

  allFields=[]

  widgetEditMode :boolean =false

  editValue

  setupError=[]

  filterPostObj:any

  previewColorpalette$: BehaviorSubject<{}> = new BehaviorSubject({})

  previewProgress$: Subject<{}> = new Subject()

  byFunction = new FormControl()

  selectedDataSet=''

  timeFilterOperator=[{
    disp:"BETWEEN",
    value:["BETWEEN"]
  }]

  titleError={
    "widgetnameAlreadyExists":"Already exists"
  }

  tableColors=[
    {
      "disp":"Default",
      "value":"#f1f6f8"
    },
    {
      "disp":"White",
      "value":"#ffffff"
    }
  ]

  setupValidation={
    "dimensions": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "sankey",
      "treemap",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "breakdown_dimension": [
      "line_stack",
      "bar_stack",
      "area_stack",
    ],
    "metrics": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "guard_guage",
      "sankey",
      "treemap",
      "label",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "limit": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "sankey",
      "treemap",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "sort": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "sankey",
      "treemap",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "default-time-range": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "guard_guage",
      "sankey",
      "treemap",
      "label",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "comparison-data-range": [
      "label"
    ],
    "filter": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "sankey",
      "treemap",
      "label",
      "horizontal_bar",
      "nightingale",
      'guard_guage',
      "line_bar",
      "custom_line"
    ]
  }

  styleValidation={
    "chart_title": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "guard_guage",
      "sankey",
      "treemap",
      "label",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "color_palette": [
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      "guard_guage",
      "sankey",
      "treemap",
      "horizontal_bar",
      "nightingale",
      "label",
      "line_bar",
      "custom_line"
    ],
    "axes": [
      "line_chart",
      "bar_chart",
      "area_chart",
      // "pie",
      // "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "horizontal_bar",
      // "polar_heatmap",
      // "polar_tangential_bar",
      // "polar_radial_bar",
      // "guard_guage",
      // "sankey",
      // "treemap",
      "line_bar",
      "custom_line"
    ],
    "legend": [
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      // "heatmap",
      // "polar_heatmap",
      // "polar_tangential_bar",
      // "polar_radial_bar",
      // "guard_guage",
      // "sankey",
      // "treemap",
      // "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ],
    "table_header": [
      "table"
    ],
    "table_body": [
      "table"
    ],
    "compact": [
      "table",
      "line_chart",
      "bar_chart",
      "area_chart",
      "pie",
      "donut",
      "line_stack",
      "bar_stack",
      "area_stack",
      "heatmap",
      "polar_heatmap",
      "polar_tangential_bar",
      "polar_radial_bar",
      // "guard_guage",
      "sankey",
      "treemap",
      "label",
      "horizontal_bar",
      "nightingale",
      "line_bar",
      "custom_line"
    ]
  }

  styleStruct={
    "color_palette": {
      "accordian_state": false,
      "disable":false
    },
    "table_header": {
      "accordian_state": false,
      "disable":false
    },
    "table_body": {
      "accordian_state": false,
      "disable":false
    },
    "axes": {
      "accordian_state": false,
      "disable":false
    },
    "legend": {
      "accordian_state": false,
      "disable":false
    },
    "compact": {
      "accordian_state": false,
      "disable":false
    }
  }

  applyStyleValidation(chartType, styleValidation: any, styleStruct: any) {
    const updatedStruct = { ...styleStruct };
  
    Object.keys(updatedStruct).forEach((key) => {
      const allowedCharts = styleValidation[key] || [];
      const isAllowed = allowedCharts.includes(chartType);
  
      
      updatedStruct[key].accordian_state = isAllowed ? false : false;
      updatedStruct[key].disable = !isAllowed;
    });

//console.log({updatedStruct})
  
    return updatedStruct;
  }

  applySetupValidation(chartType, styleValidation: any, styleStruct: any) {
    const updatedStruct = { ...styleStruct };
  
    Object.keys(updatedStruct.setup).forEach((key) => {
      if(key != "widget_name" && key != "chart-type"){
        const allowedCharts = styleValidation[key] || [];
        const isAllowed = allowedCharts.includes(chartType);

//console.log(key , "--->", isAllowed)
    
        
        updatedStruct.setup[key].accordianState = (chartType != 'label' && chartType!= 'guard_guage') &&  key === 'dimensions' ? true : false;
        updatedStruct.setup[key].disable = !isAllowed;

        if(chartType == 'label' || chartType == 'guard_guage'){
          updatedStruct.setup["metrics"].accordianState = true
        }
      }
    });

//console.log({updatedStruct})
  
    return updatedStruct;
  }

  styleDispMap={
    "color_palette":"Color palette",
    "table_header":"Table header",
    "table_body":"Table body",
    "axes":"Axes",
    "legend":"Legend",
    "compact":"Compact number"
  }

  fontSize=[
    {
      "disp":"10px",
      "value":"10",
    },
    {
      "disp":"12px",
      "value":"12",
    },
    {
      "disp":"14px",
      "value":"14",
    }
  ]

  textAlign=[
    {
      "disp":"Center",
      "value":"center"
    },
    {
      "disp":"Start",
      "value":"start"
    },
    {
      "disp":"End",
      "value":"end"
    }
  ]

  axisLocation=[
    {
      "disp":"Start",
      "value":"start"
    },
    {
      "disp":"Middle",
      "value":"middle"
    },
    {
      "disp":"End",
      "value":'end'
    }
  ]

  legendIcons=[
    {
      "disp":"Circle",
      "value":"circle"
    },
    {
      "disp":"Rectangle",
      "value":"rect"
    },
    {
      "disp":"Triangle",
      "value":"triangle"
    },
    {
      "disp":"Diamond",
      "value":"diamond"
    },
    {
      "disp":"Pin",
      "value":"pin"
    },
    {
      "disp":"Arrow",
      "value":"arrow"
    },
    {
      "disp":"None",
      "value":"none"
    },
    {
      "disp":"Round rectangle",
      "value":"roundRect"
    }
  ]

  legendType=[
    {
      "disp":"Default",
      "value":"plain"
    },
    {
      "disp":"Scrollable",
      "value":"scroll"
    }
  ]

  compactType=[
    {
      "disp":"Number",
      "value":"number"
    },
    {
      "disp":"Size",
      "value":"size"
    }
  ]




  timeData = [
    {
      "disp": "Last 1 Hour",
      "value": [
        -1,
        "hour",
        1
      ]
    },
    {
      "disp": "Today",
      "value": [
        0,
        "day",
        0
      ]
    },
    {
      "disp": "Yesterday",
      "value": [
        -1,
        "day",
        1
      ]
    },
    {
      "disp": "last 7 Days",
      "value": [
        -1,
        "day",
        6
      ]
    },
    {
      "disp": "Last 30 Days",
      "value": [
        -1,
        "day",
        29
      ]
    },
    {
      "disp": "All Time",
      "value": [
        -1,
        "day",
        999
      ]
    }
  ]

  selectedFilters=[]

  dimensionFunctions=[
    {
      "disp":"Hourly",
      "value":"hour",
      "status":"1",
      "type":"timestamp"
    },
    {
      "disp":"Daily",
      "value":"day",
      "status":"1",
      "type":"timestamp"
    },
    // {
    //   "disp":"Weekly",
    //   "value":"weekly",
    //   "status":"1",
    //   "type":"timestamp"
    // },
    // {
    //   "disp":"Monthly",
    //   "value":"monthly",
    //   "status":"1",
    //   "type":"timestamp"
    // },
    // {
    //   "disp":"Yearly",
    //   "value":"yearly",
    //   "status":"1",
    //   "type":"timestamp"
    // },
    {
      "disp":"Lower",
      "value":"lower",
      "status":"1",
      "type":"text"
    },
    {
      "disp":"Upper",
      "value":"upper",
      "status":"1",
      "type":"text"
    }
  ]

  dimensionFunctionsFiltered= JSON.parse(JSON.stringify(this.dimensionFunctions))

  metricFunctions=[
    // {
    //   "disp":"Count",
    //   "value":"count",
    //   "status":"1"
    // },
    {
      "disp":"Sum",
      "value":"sum",
      "status":"1"
    },
    {
      "disp":"Count distinct",
      "value":"count_distinct",
      "status":"1"
    },
    {
      "disp":"Avg",
      "value":"avg",
      "status":"1"
    },
    {
      "disp":"Min",
      "value":"min",
      "status":"1"
    },
    {
      "disp":"Max",
      "value":"max",
      "status":"1"
    },
    {
      "disp":"Percentage",
      "value":"percentage",
      "status":"1"
    }
  ]

  selectorChart=""

  metricFunctionsFiltered= JSON.parse(JSON.stringify(this.metricFunctions))


  functions=[
    {
      "disp":"CNT",
      "value":"Count",
      "status":"1"
    },
    {
      "disp":"SUM",
      "value":"sum",
      "status":"1"
    }
  ]

  limit=[
    {
      "disp":"Top 10",
      "value":"top_10",
      "status":"1"
    },
    {
      "disp":"Bottom 10",
      "value":"bottom_10",
      "status":"1"
    }
  ]

  dimensions=[]
  metrics=[]

  metricsAndDimensions=[]


  dataSetOptions:any

  setupDispMap={
    "dimensions" : "Dimensions",
    "breakdown_dimension" : "Breakdown dimension",
    "metrics" : "Metrics",
    "limit" : "Limit",
    "sort" : "Sort",
    "default-time-range":"Default time range",
    "comparison-data-range":"Comparison date range",
    "filter" : "Filter"
  }

  sortValues=[
    {
      "disp":"Ascending",
      "value":"ASC"
    },
    {
      "disp":"Descending",
      "value":"DESC"
    }
  ]

  timeRangeValues=[
    {
      "disp":"Auto",
      "value":"auto"
    },
    {
      "disp":"Custom",
      "value":"custom"
    }
  ]

  setupFormValue={"setup": {
    "widget_name": "",
    "chart-type": "basic-line",
    "dimensions": {
      "accordianState": false,
      "disable": false,
      "drill_down": false,
      "fields": [
        {
          "function": "",
          "field": ""
        }
      ]
    },
    "breakdown_dimension": {
      "accordianState": "false",
      "disable": "true",
      "breakdowns": [
        {
          "function": "",
          "field": ""
        }
      ]
    },
    "metrics": {
      "accordianState": false,
      "disable": false,
      "optional_metrics": false,
      "metrics_slider": true,
      "metric_fields": [
        {
          "function": "",
          "field": ""
        }
      ]
    },
    "limit": {
      "accordianState": false,
      "disable": false,
      "rules": [
        {
          "field": "",
          "limit": "",
          "by": {
            "function": "",
            "field": ""
          }
        }
      ]
    },
    "sort": {
      "accordianState": false,
      "disable": false,
      "fields": [
        ""
      ],
      "order": "DESC"
    },
    "default-time-range": {
      "accordianState": false,
      "disable": false,
      mode: "auto",
      "value": [
        -1,
        "day",
        29
      ]
    },
    "comparison-data-range":{
      "accordianState": false,
      "disable": true,
      "value": [
        -1,
        "day",
        29
      ]
    },
    "filter": {
      "accordianState": false,
      "disable": false,
      "filter_groups": [
        {
          "cdn_operator": "AND",
          "conditions": [
            {
              "field": "action",
              "type": "text",
              "operator": "=",
              "value": "accept"
            },
            {
              "field": "srcip",
              "type": "inet",
              "operator": "=",
              "value": "12.0.0.1"
            }
          ]
        },
        {
          "cdn_operator": "AND",
          "conditions": [
            {
              "field": "type",
              "type": "text",
              "operator": "=",
              "value": "traffic"
            }
          ]
        }
      ],
      "set_operator": [
        "AND"
      ]
    }
  }
}

  defaultSetupForm = {
    setup: {
      widget_name: '',
  
      dimensions: {
        drill_down: false,
        fields: [
          { function: '', field: '' }
        ]
      },
  
      breakdown_dimension: {
        breakdowns: [
          { function: '', field: '' }
        ]
      },
  
      metrics: {
        optional_metrics: false,
        metrics_slider: true,
        metric_fields: [
          { function: '', field: '' }
        ]
      },
  
      limit: {
        rules: [
          {
            field: '',
            limit: '',
  
            by: {
              function: '',
              field: ''
            }
          }
        ]
      },
  
      sort: {
        fields: [],
        order: 'DESC'
      },
  
      'default-time-range': {
        mode: "auto",
        value: [
          -1,
          "day",
          29
        ]
      },
      "comparison-data-range":{
        value: [
          -1,
          "day",
          29
        ]
      },
  
      filter: {}
    }
  }


  setupForm = new FormGroup({
    setup: new FormGroup({
      widget_name: new FormControl('',{
        validators:[Validators.required],
        asyncValidators: [WidgetnameValidator.createValidator(this.widgetbuilderservice,this)]
      }),
  
      dimensions: new FormGroup({
        drill_down: new FormControl(null),
        fields: new FormArray([
          this.createField()
        ])
      }),
  
      breakdown_dimension: new FormGroup({
        breakdowns: new FormArray([
          this.createField()
        ])
      }),
  
      metrics: new FormGroup({
        optional_metrics: new FormControl(null),
        metrics_slider: new FormControl(null),
        metric_fields: new FormArray([
          this.createField()
        ])
      }),
  
      limit: new FormGroup({
        rules: new FormArray([
          this.createLimitRule(null, true)
        ])
      }),
  
      sort: new FormGroup({
        fields: new FormArray([
          new FormControl("")
        ]),
        order: new FormControl(null)
      }),
  
      'default-time-range': new FormGroup({
        mode: new FormControl(null),
        value: new FormControl(null)
      }),
      'comparison-data-range': new FormGroup({
        value: new FormControl(null)
      }),
  
      filter: new FormGroup({})
    })
  });

  "styleForm"= new FormGroup({
    "widget_title" : new FormControl(),
    "color_palette" : new FormControl(),
    "table_header" : new FormGroup({
      "enable" : new FormControl(),
      "font-size" : new FormControl('12'),
      "background-color" : new FormControl('#f1f6f8'),
      "text-align" : new FormControl('left')
    }),
    "table_body": new FormGroup({
      "font-size" : new FormControl('12'),
      "background-color" : new FormControl('#f1f6f8'),
    }),
    "axes" : new FormGroup({
      "x-axis" : new FormGroup({
        "enable" : new FormControl(),
        "name" : new FormControl(),
        "position" : new FormControl(),
        "font-size" : new FormControl()
      }),
      "y-axis" : new FormGroup({
        "enable" : new FormControl(),
        "name" : new FormControl(),
        "position" : new FormControl(),
        "font-size" : new FormControl()
      })
    }),
    "legend" : new FormGroup({
      "enable" : new FormControl(),
      "icon" : new FormControl(),
      "type" : new FormControl()
    }),
    "compact" : new FormGroup({
      "mode" : new FormControl(),
      "type" : new FormControl()
    })
    
  })

  createField(func: string | null = null, field: string | null = null): FormGroup {
    
    return new FormGroup({
      function: new FormControl(func),
      field: new FormControl(field),
      disp: new FormControl(field,[Validators.required,,Validators.pattern(/^[A-Za-z _\-\$.]+$/)])
    });
  }

  // createField = (func: string | null = null, field: string | null = null):  => {

  //   return {
  //     function: new FormControl(func),
  //     field: new FormControl(field),
  //     disp: new FormControl(
  //       field,
  //       [
  //         Validators.required,
  //         this.dispDuplicateCheck(),
  //         Validators.pattern(/^[A-Za-z _\-\$.]+$/)
  //       ]
  //     )
  //   };
  // }

  createLimitRule(data?: any, includeBy: boolean = false): FormGroup {
    const group = new FormGroup<{ [key: string]: any }>({
      field: new FormControl(data?.field ?? null),
      limit: new FormControl(data?.limit ?? null)
    });
  
    if (includeBy) {
      group.addControl(
        'by',
        new FormGroup({
          function: new FormControl(data?.by?.function ?? null),
          field: new FormControl(data?.by?.field ?? null)
        })
      );
    }
  
    return group;
  }

  setLimitRules(data: any[]) {
    const rulesArray = this.setupForm.get([
      'setup',
      'limit',
      'rules'
    ]) as FormArray;
  
    rulesArray.clear();
  
    data.forEach((rule, index) => {
      const isFirst = index === 0;
  
      rulesArray.push(
        this.createLimitRule(rule, isFirst)
      );
    });
  }

  addLimitRule(data?: any) {
    const rules = this.setupForm.get(['setup', 'limit', 'rules']) as FormArray;
    if(rules.value.length < this.setupForm.get('setup').get('dimensions').get('fields').value.length){
      
    
      const isFirst = rules.length === 0;
    
      rules.push(
        this.createLimitRule(data ?? {}, isFirst)
      );
    }
  }

  removeLimitRule(index: number) {
    if( index == 0){
      let fields=this.setupForm.get('setup').get('limit').get('rules') as FormArray
      fields.at(index).reset()
      this.byFunction.reset()
    }else{
    const arr = this.setupForm.get(['setup','limit','rules']) as FormArray;
    arr.removeAt(index);
    }
  }

  removeControl(path: string[], index: number) {
    const arr = this.setupForm.get(path) as FormArray;
    arr.removeAt(index);
  }

  removeSort(i){
    if(i == 0){
      let fields=this.setupForm.get('setup').get('sort').get('fields') as FormArray
      fields.at(i).reset()
    }else{
      this.removeControl(['setup','sort','fields'], i);
    }
    
  }

  removeDimension(i){
    // console.log(this.selectedChart)
    let min = this.selectedChart.requirements.minDimensions
    if(i < min){
      let fields=this.setupForm.get('setup').get('dimensions').get('fields') as FormArray
      fields.at(i).get('function').reset()
      fields.at(i).get('field').reset()
      fields.at(i).get('disp').reset()
    }else{
      this.removeControl(['setup','dimensions','fields'], i);
      this.clearFormArray(['setup', 'limit', 'rules']);
    }
    
  }

  removeMetric(i){
    let min = this.selectedChart.requirements.minMetrics
    if( i < min){
      let fields=this.setupForm.get('setup').get('metrics').get('metric_fields') as FormArray
 
      fields.at(i).get('function').reset()
      fields.at(i).get('field').reset()
      fields.at(i).get('disp').reset()
    }else{
      this.removeControl(['setup', 'metrics', 'metric_fields'], i);
    }
    
  }

  removeBreakdown(i){
    this.removeControl(['setup', 'breakdown_dimension', 'breakdowns'], i);
  }

  addToArray(path: string[], control: any) {
    const arr = this.setupForm.get(path) as FormArray;
    arr.push(control);
  }

  // clearFormArray(path: string[]) {
  //   const array = this.setupForm.get(path) as FormArray;
  //   array.clear();
  // }
  clearFormArray(path: string[]) {
    const array = this.setupForm.get(path) as FormArray;
  
    if (!array || array.length === 0) return;
  
    while (array.length > 1) {
      array.removeAt(1);
    }
  }

  getSelectedDimensions(): any[] {
    const fieldsArray = this.setupForm
      .get('setup.dimensions.fields') as FormArray;
  
    const fieldStrings = fieldsArray.controls
      .map(control => control.get('field')?.value)
      .filter(value => !!value);
  
    const allOptions = this.dimensions;
  
    return allOptions.filter(option =>
      fieldStrings.includes(option.value)
    );
  }

  getDimensions(): any[] {
    const fieldsArray = this.setupForm
      ?.get('setup.dimensions.fields') as FormArray;
 
    if (!fieldsArray || !fieldsArray.controls?.length) {
      return [];
    }
  
    const fieldStrings = fieldsArray.controls
      .map(control => control.get('field')?.value)
      .filter(value => !!value);
  
    if (!fieldStrings.length) {
      return [];
    }
  
    const allOptions = this.dimensions;
  
    if (!allOptions || !allOptions.length) {
      return [];
    }

    let returnArr = JSON.parse(JSON.stringify(allOptions.filter(option =>
      fieldStrings.includes(option?.value)
    )))

    // console.log(returnArr)

    // returnArr.forEach(val=>{
    //   val.disp = this.getDisp(val.value)
    // })

    return returnArr
  }

  getDisp(field){
    
    let allFields = this.getDispList()

    return allFields.filter(v => v.field == field)[0]?.disp
  }

  getDispList(){
    let dim = this.setupForm.get('setup').get('dimensions').get('fields').getRawValue()
    let met = this.setupForm.get('setup').get('metrics').get('metric_fields').getRawValue()

    return [...dim,...met]
  }

 

//   dispDuplicateCheck():ValidatorFn{
//     return (control: AbstractControl): ValidationErrors | null => {

//     if (!control.parent) {
//       return null;
//     }

//     let allFields = this.getDispList()

//     let found = allFields.find(val=> val.disp == control.value)

//     return !found
//       ? null
//       : { invalidToDate: true };
//   }
// }

dispDuplicateCheck():ValidatorFn{
  return (control: AbstractControl): ValidationErrors | null => {

  if (!control.parent) {
    return null;
  }

  let allFields = this.getDispList()

  let found = allFields.find(val=> val.disp == control.value)

  return !found
    ? null
    : { invalidToDate: true };
}
}

getSortAllFields(){
  const fieldsArray = this.setupForm
  ?.get('setup.dimensions.fields') as FormArray;

  const metArray = this.setupForm
  ?.get('setup.metrics.metric_fields') as FormArray;

  let sortArray = this.setupForm
  ?.get('setup.sort.fields').value ? this.setupForm
  ?.get('setup.sort.fields').value :[] ;

  sortArray = sortArray.filter(val=> val != '' || val != null )

if ((!fieldsArray || !fieldsArray.controls?.length) && (!metArray || !metArray.controls?.length) ) {
  return [];
}

const fieldStrings = fieldsArray.controls
  .map(control => control.get('field')?.value)
  .filter(value => !!value);

const metStrings = metArray.controls
  .map(control => control.get('field')?.value)
  .filter(value => !!value);

if (!fieldStrings.length && !metStrings.length) {
  return [];
}

const allOptions = JSON.parse(JSON.stringify(this.dimensions));

const metOptions = JSON.parse(JSON.stringify(this.metricsAndDimensions));

if ((!allOptions || !allOptions.length) && (!metOptions || !metOptions.length)) {
  return [];
}

let dim =  allOptions.filter(option =>
  fieldStrings.includes(option?.value)
);

let met = metOptions.filter(option =>
  metStrings.includes(option?.value)
);

let returnArr= JSON.parse(JSON.stringify([...dim, ...met]))

return returnArr
}

getSortFields( sortIndex?){
    const fieldsArray = this.setupForm
    ?.get('setup.dimensions.fields') as FormArray;

    const metArray = this.setupForm
    ?.get('setup.metrics.metric_fields') as FormArray;

    let sortArray = this.setupForm
    ?.get('setup.sort.fields').value ? this.setupForm
    ?.get('setup.sort.fields').value :[] ;

    sortArray = sortArray.filter(val=> val != '' || val != null )

  if ((!fieldsArray || !fieldsArray.controls?.length) && (!metArray || !metArray.controls?.length) ) {
    return [];
  }

  const fieldStrings = fieldsArray.controls
    .map(control => control.get('field')?.value)
    .filter(value => !!value);

  const metStrings = metArray.controls
    .map(control => control.get('field')?.value)
    .filter(value => !!value);

  const metDisp = metArray.controls
  .map(control => control.get('disp')?.value)
  .filter(value => !!value);

  if (!fieldStrings.length && !metStrings.length) {
    return [];
  }

  const allOptions = JSON.parse(JSON.stringify(this.dimensions));

  const metOptions = JSON.parse(JSON.stringify(this.metricsAndDimensions));

  if ((!allOptions || !allOptions.length) && (!metOptions || !metOptions.length)) {
    return [];
  }

  let dim =  allOptions.filter(option =>
    fieldStrings.includes(option?.value)
  );

  let met = metOptions.filter(option =>
    metStrings.includes(option?.value)
  );

//console.log({metStrings})

//console.log({metOptions})

  met.forEach(val=>{
    val.disp=metDisp[metStrings?.findIndex(dat=> dat == val.value)]
  })

//console.log({met})

  

  let returnArr= JSON.parse(JSON.stringify([...dim, ...met]))

  // returnArr.forEach(val=>{
  //   val.disp = this.getDisp(val.value)
  // })
let selectedField 
  if(typeof(sortIndex) == 'number'){

    selectedField = sortArray[sortIndex]
    returnArr = returnArr.filter(val => !sortArray.includes(val.value) || val.value == selectedField );
  }
  else{
    returnArr = returnArr.filter(val => !sortArray.includes(val.value));
  }

  

  

// console.log({returnArr})
// console.log({sortArray})
  return returnArr;

 
  }

  resetChart(){
    this.selectorChart=''
//console.log("Chart Service 1 =---->",this.chartType)
    this.chartType=''
    this.selectedChart=''
//console.log("On Reset")
    this.refreshChart('reset')
    this.inputData={"title":"","subtitle":null,"type":"","widgetdata":{},"style":{}}
  }

  resetForm(){
    this.setupForm.reset(); 

    this.byFunction.reset()

  

    this.setupForm.get('setup').get('default-time-range').get('mode').setValue('auto')
    this.setupForm.get('setup').get('default-time-range').get('value').setValue([
      -1,
      "day",
      29
    ])
    this.setupForm.get('setup').get('sort').get('order').setValue('DESC')

    this.clearFormArray(['setup', 'limit', 'rules']);
    this.clearFormArray(['setup', 'dimensions', 'fields']);
    this.clearFormArray(['setup', 'metrics', 'metric_fields']);
    this.clearFormArray(['setup', 'breakdown_dimension', 'breakdowns']);
    this.clearFormArray(['setup', 'sort', 'fields']);

    
    this.setMetric()
  }

  resetSetupForm(){

    this.resetForm()
    this.styleForm.reset();{emitEvent:false}

    this.styleForm.get('compact').get('mode').setValue('auto',{emitEvent:false})
    this.styleForm.get('compact').get('type').setValue('number',{emitEvent:false})


    this.resetChart()

    this.filterPostObj={}

    // this.widgetType.reset({emitEvent:false})

  
    this.resetFilterCondition()


  }

  resetFilterCondition() {

    const filterCondition =
      this.filter.get('filtercondition') as FormArray;
  
    if (!filterCondition || filterCondition.length === 0) {
      return;
    }
  
    // Keep only first filter condition
    for (let i = filterCondition.length - 1; i >= 1; i--) {
      filterCondition.removeAt(i, { emitEvent: false });
    }
  
    const conditionLines =
      filterCondition.at(0).get('conditionLines') as FormArray;
  
    if (!conditionLines || conditionLines.length === 0) {
      return;
    }
  
    // Keep only first condition line
    for (let i = conditionLines.length - 1; i >= 1; i--) {
      conditionLines.removeAt(i, { emitEvent: false });
    }
  
    // Reset first condition line
    conditionLines.at(0).reset(
      {
        eventField: null,
        fromDate: null,
        operator: [],
        toDate: null,
        conditionValue: [],
        conditionInput: null,
        includeNot: false
      },
      { emitEvent: false }
    );
    const conditionValue =
    conditionLines.at(0).get('conditionValue') as FormArray;
  
  conditionValue.clear({ emitEvent: false });
    // Reset first filter condition
    filterCondition.at(0).patchValue(
      {
        operationconditionLine: true,
        includeNot: false,
        operationConditionset: '',
        notOperator: null
      },
      { emitEvent: false }
    );

  
  
//console.log(this.filter.getRawValue());
  }

 

  setMetric(){
    let metric = this.setupForm.get('setup').get('metrics').get('metric_fields') as FormArray

    if(this.selectorChart === 'guard_guage'){
//console.log("gauge")
      metric.at(0).get('function').setValue('percentage')
    }else{
//console.log("not gauge")
      metric.at(0).get('function').setValue('sum')
    }
   
    const exists = this.metrics.some(obj => obj.value.includes("eventcount"));
    if(exists){
      metric.at(0).get('field').setValue('eventcount')
    }else{
      metric.at(0).get('field').setValue(this.metrics[0]?.value)
    }

    setTimeout(() => {
      let limit = this.setupForm.get('setup').get('limit').get('rules') as FormArray
      if(!limit.at(0).get('limit').value){
        limit.at(0).get('limit').setValue('top_10')
      }
      if(exists){
        this.byFunction.setValue("sum eventcount")
      }else{
        this.byFunction.setValue("sum "+this.metrics[0]?.value)
      }
    }, 100);
    

    
  }

  setFormArray(path: string[], data: any[] = [], creator: (func : any, field) => FormGroup) {

    const array = this.setupForm.get(path) as FormArray;
  
    array.clear();
  
    data?.forEach(item => {
      array.push(creator(item.function,item.field));
    });
  }

  setSimpleArray(path: string[], data: any[] = []) {
    const array = this.setupForm.get(path) as FormArray;
  
    array.clear();
  
    data?.forEach(item => {
      array.push(new FormControl(item));
    });
  }

  initializeSetupForm(data: any) {

    this.resetForm()

    const setup = data.setup;
  
    //  Patch simple values
    this.setupForm.patchValue({
      setup: {
        widget_name: setup.widget_name,
  
        dimensions: {
          drill_down: setup.dimensions?.drill_down
        },
  
        metrics: {
          optional_metrics: setup.metrics?.optional_metrics,
          metrics_slider: setup.metrics?.metrics_slider
        },
  
        sort: {
          order: setup.sort?.order
        },
  
        'default-time-range': setup['default-time-range']
      }
    });
  
    //  Build arrays dynamically
    this.setFormArray(['setup', 'dimensions', 'fields'], setup.dimensions?.fields, this.createField.bind(this));
  
    this.setFormArray(['setup', 'breakdown_dimension', 'breakdowns'], setup.breakdown_dimension?.breakdowns, this.createField.bind(this));
  
    this.setFormArray(['setup', 'metrics', 'metric_fields'], setup.metrics?.metric_fields, this.createField.bind(this));
  
    this.setLimitRules(setup.limit?.rules);
  
    //  Simple array (strings)
    this.setSimpleArray(['setup', 'sort', 'fields'], setup.sort?.fields);
  }


  getDisplayByValue(value: string): string | null {
    for (const category of this.ListOfCharts) {
      const option = category.options.find((o: any) => o.value === value);
  
      if (option) {
        return option.display;
      }
    }
  
    return null;
  }




   
  get filtercondition() {
    return this.filter.get('filtercondition') as FormArray;
  }

  conditionlines(index: number) {
    return this.filtercondition.at(index).get('conditionLines') as FormArray;
  }

  conditioneventField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex).get('eventField');
  }

  conditionvalue(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('conditionValue') as FormArray;
  }

  conditionSetButtonValue(index: number) {
    return this.filtercondition.at(index).get('operationConditionset');
  }

  conditionNotButtonValue(index: number) {
    return this.filtercondition.at(index).get('notOperator');
  }

  operatorField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('operator');
  }

  fromDate(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('fromDate');
  }

  toDate(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).controls[lineindex].get('toDate');
  }

  includeNot(setindex: number, lineindex: number){
    return this.conditionlines(setindex).controls[lineindex].get('includeNot');
  }

  conditionInputField(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex).get('conditionInput');
  }

  conditionGroup(setindex: number, lineindex: number) {
    return this.conditionlines(setindex).at(lineindex);
  }

  processSet(filterconditionset: any) {
    const conditionarr = [];
    for (let j = 0; j < filterconditionset.conditionLines.length; j++) {
      if (filterconditionset.conditionLines[j].eventField) {
        const cond_obj = {};

        // cond_obj["fromDate"] = filterconditionset.conditionLines[j].fromDate
        // cond_obj["toDate"] = filterconditionset.conditionLines[j].toDate


        cond_obj["field"] = filterconditionset.conditionLines[j].eventField.field;
        // cond_obj["field"] = filterconditionset.conditionLines[j].eventField;
        cond_obj["type"] = filterconditionset.conditionLines[j].eventField.type;
        // cond_obj["type"] = this.widgetbuildervarservice.getDataTypeForField(filterconditionset.conditionLines[j].eventField)
        cond_obj["operator"] = filterconditionset.conditionLines[j].operator[0];
        if (filterconditionset.conditionLines[j].operator[0] == "=" || filterconditionset.conditionLines[j].operator[0] == "!=") {
          cond_obj["value"] = filterconditionset.conditionLines[j].conditionValue[0];
        } else {
          cond_obj["value"] = filterconditionset.conditionLines[j].conditionValue;
        }
        if (filterconditionset.conditionLines[j].operator[0] == "BETWEEN"){
          cond_obj["value"] =[]
          cond_obj["value"].push(filterconditionset.conditionLines[j].fromDate)
          cond_obj["value"].push(filterconditionset.conditionLines[j].toDate)
        }
        // cond_obj["NOT"] = filterconditionset.conditionLines[j].includeNot
        conditionarr.push(cond_obj);
      }
    }
    return conditionarr;
  }


  processFilters(filterconditionvalue) {
    // const filterconditionvalue = this.filtercondition.getRawValue();
    const filterconditions = [];
    const set_operators = [];
    for (let i = 0; i < filterconditionvalue.length; i++) {
      const setobj = {};
      const conditionarr = this.processSet(filterconditionvalue[i]);
      if (conditionarr.length) {
        if (filterconditionvalue[i].operationconditionLine) {
          setobj["cdn_operator"] = "AND";
        } else {
          setobj["cdn_operator"] = "OR";
        }

        // if(filterconditionvalue[i].includeNot){
        //   setobj["cdn_operator"] = setobj["cdn_operator"]+" NOT"
        // }
        setobj["conditions"] = conditionarr;
        setobj["includeNot"] = filterconditionvalue[i].includeNot
        filterconditions.push(setobj);
        if (filterconditionvalue[i].operationConditionset) {
          // set_operators.push(filterconditionvalue[i].notOperator? filterconditionvalue[i].operationConditionset+' NOT' : filterconditionvalue[i].operationConditionset);
          set_operators.push(filterconditionvalue[i].operationConditionset);
        }
      }
    }

    return {
      filterconditions,
      set_operators
    }
  }

  addAnotherSet() {
    this.addconditionSet();
  }

  addFilterCondition(setindex: number) {
    //console.log(this.widgetbuildervarservice.wb_meta.wdigetpannel.filter_condition.options)
        if (this.conditionlines(setindex).controls.length < 5) {
          this.conditionlines(setindex).push(this.addCondition());
        }
      }


  formatFilterConditions() {
    let data = this.filterPostObj
    // Handle empty input
    if (
      !data ||
      !Array.isArray(data.filterconditions) ||
      data.filterconditions.length === 0
    ) {
      return [];
    }
  
    const result = [];
  
    data.filterconditions.forEach((group, groupIndex) => {
      // Skip invalid groups
      if (!group || !Array.isArray(group.conditions)) {
        return;
      }
  
      // Opening bracket
      result.push({
        value: group.includeNot ? "NOT (" : "(",
        type: "text"
      });
  
      // Conditions inside group
      group.conditions.forEach((condition, conditionIndex) => {
        if (!condition) return;
  
        let conditionText = "";
  
        // Handle BETWEEN operator
        if (
          condition.operator === "BETWEEN" &&
          Array.isArray(condition.value)
        ) {
          conditionText = `${condition.field} ${condition.operator} ${condition.value[0]} and ${condition.value[1]}`;
        } else {
          conditionText = `${condition.field} ${condition.operator} ${condition.value}`;
        }
  
        // Add condition chip
        result.push({
          value: conditionText,
          type: "text" // chip
        });
  
        // Add condition operator between conditions
        if (conditionIndex < group.conditions.length - 1) {
          result.push({
            value: group.cdn_operator,
            type: "text"
          });
        }
      });
  
      // Closing bracket
      result.push({
        value: ")",
        type: "text"
      });
  
      // Add set operator between filter groups
      if (
        groupIndex < data.filterconditions.length - 1 &&
        data.set_operators?.[groupIndex]
      ) {
        result.push({
          value: data.set_operators[groupIndex],
          type: "text"
        });
      }
    });
  
    return result;
  }


  getFilterStrings(): string[] {
    const filter = this.filterPostObj?.filterconditions;

    // console.log("Filter Obj =---->",this.filterPostObj)
  
    if (!filter?.length) return [];
  
    const result: string[] = [];
  
    filter.forEach(group => {
      group.conditions?.forEach((cond,index) => {
        if(cond.field != 'time'){
          if (cond.field && cond.operator && cond.value !== undefined) {
            if(cond.value){
              result.push(`${cond.field} ${cond.operator} ${cond.value}`);
            }else{
              let val=''
              cond.value.forEach((key,i)=>{
                if(i !=0){
                  val +=''
                }else{
                  val +=key
                }
              })
              result.push(`${cond.field} ${cond.operator} ${val}`);
            }
            
          }
        }else{
          if(cond.field && cond.operator && cond.value !== undefined){
            result.push(`${cond.field} ${cond.operator} ${cond.value[0]} and ${cond.value[1]}`)
          }

        }
      });
    });
  
    return result;
  }

  addDimension(data?){
    if(this.setupForm.get('setup').get('dimensions').get('fields').value.length < this.selectedChart.requirements.maxDimensions){
      let control = this.createField(data ?? null)
      this.addToArray(
        ['setup','dimensions','fields'],
        control
      );

      control.get('field').valueChanges.subscribe(val=>{
        // console.log("Val =---->",val)
        if(val){
          if(!control.get('disp').touched){
            control.get('disp').setValue(this.getDispForField(val),{emitEvent:false})
          }
        }
      })

      control.get('function').valueChanges.subscribe(val=>{

        if(val == 'day' || val == 'hour'){
          if(this.getDataTypeForField(control.get('field').value) != 'timestamp'){
//console.log("Not time")
            control.get('field').reset()
            control.get('disp').reset()
          }
        }else{
          if(this.getDataTypeForField(control.get('field').value) == 'timestamp'){
//console.log("Time")
            control.get('field').reset()
            control.get('disp').reset()
          }
        }
      })
    }
   }

   addMetric(data?: any) {
    if(this.setupForm.get('setup').get('metrics').get('metric_fields').value.length < this.selectedChart.requirements.maxMetrics){
      let control = this.createField(data ?? null)
      this.addToArray(
        ['setup','metrics','metric_fields'],
       control
      );

      control.get('function').valueChanges.subscribe(val=>{
// console.log("val =-->",val)
        control.get('field').reset()
        
      })
      control.get('field').valueChanges.subscribe(val=>{
        // console.log("Val =---->",val)
        if(val){
          if(!control.get('disp').touched){
            // control.get('disp').setValue(this.getDispForField(val),{emitEvent:false})
            control.get('disp').setValue(this.metricFunctionsFiltered.find(val => val.value == control.get('function').value)?.disp +" "+ this.metricsAndDimensions.find(val => val.value == control.get('field').value)?.disp,{emitEvent:false})

          }
        }
        let sortFields =this.setupForm.get('setup').get('sort').get('fields') as FormArray

//console.log("Sort Fields =---->",sortFields.value,"->",this.getSortFields())

        sortFields.value.forEach((sort,i)=>{
          if(this.getSortAllFields().find(key=> key.value == sort)){
//console.log("TRUe")

          }else{
            sortFields.at(i).reset()
          }
        })
        
      })
    }
  }

  

  addBreakdown(data?: any) {
    if(this.setupForm.get('setup').get('dimensions').get('fields').value.length < this.selectedChart.requirements.maxDimensions){
      this.addToArray(
        ['setup','breakdown_dimension','breakdowns'],
        this.createField(data ?? null)
      );
    }
  }

  addSort(data?: any){

    // console.log("Add sort")
    // console.log(this.getSortFields().length)

    let sortArray = this.setupForm.get('setup').get('sort').get('fields') as FormArray
    // console.log(this.getSortFields().length >= 1, sortArray.length <= this.getSortFields().length,sortArray.length)
    if(this.getSortFields().length >= 1 && sortArray.length < this.setupForm.get('setup').get('dimensions').get('fields').value.length + this.setupForm.get('setup').get('metrics').get('metric_fields').value.length   ){
      // console.log("Sort added")
      this.addToArray(
        ['setup','sort','fields'],
        new FormControl(data ?? "")
      );
    }
  }

  getDimAndMet(){
    let dim=0
    let met=0
    let dimensions=[]
    let metrics =[]
    let metANdDim=[]
//console.log("Mock Data on GET DIM",this.mockTableData.headers)
    this.mockTableData.headers.forEach(val=>{
      if(val.category === "dimension"){
        dim++
        dimensions.push(val)
      }else if(val.category === "metric"){
        met++
        metrics.push(val)
      }
      metANdDim.push(val)
    })
    this.dataSetFields.no_of_dimensions = dim
    this.dataSetFields.no_of_metrics = met

    this.buildDimAndMet(dimensions,metrics,metANdDim)
  }

  buildDimAndMet(dim,met,metANdDim){
    dim.forEach(val=>{
      val["state"]=1
    })
    met.forEach(val=>{
      val["state"]=1
    })
    metANdDim.forEach(val=>{
      val["state"]=1
    })
    this.dimensions = dim
    this.metrics = met
    this.metricsAndDimensions=metANdDim
    // this.metricsAndDimensions.push({
    //   "disp": "*",
    //   "type": "text",
    //   "value": "*",
    //   "category": "dimension",
    //   "state": 1
    // })

    // console.log("Dimensions =---->",this.widgetbuildervarservice.dimensions,"\n Metrics =---->",this.widgetbuildervarservice.metrics)
  }

  dataSetOnEdit(): void {
    this.getDimAndMet()
    // console.log(this.widgetbuildervarservice.selectionForm)
    // console.log("Selection Form =---->",this.selectionForm.valid)
    // if (this.selectionForm.valid) {
      // this.getDataSet()
      const payload = this.selectionForm.getRawValue();
//console.log('[DataVisualization] Saved selection:', payload);
      this.dataSet = payload

      // this.widgetbuildervarservice.dataSetOptions['data_set'][payload.device].forEach(val=>{
      //   if(val.value === payload.data){
      //     // console.log(val)
      //     this.widgetbuildervarservice.dataSetFields.no_of_dimensions=val.no_of_dimensions
      //     this.widgetbuildervarservice.dataSetFields.no_of_metrics=val.no_of_metrics
      //   }
      // })
      // this.overLayRef._cube.next()
      // this.overLayRef.close()
      // this.selectedChart={}
      // this.chartType=''
      this.stepTabs[0].enable=true

//console.log("DataSet =---->",this.dataSet)

//console.log("DataSetOptions =---->",this.dataSetOptions)

      this.selectedDataSet = this.getDisplayString()
    // }

    this.changeChartState()
    
   
  }

  getDisplayString() {
    // const input = { technology: 'Firewall', platform_id: 22, data_set: 2 };

    // if(this.dataSetOptions["event_logs"]?.technology){

    // }else{
    //   let dataset = JSON.parse(JSON.stringify(this.dataSetOptions))

    //   this.dataSetOptions={}
  
    //   this.dataSetOptions["event_logs"] = dataset
    // }

    // let input =this.dataSet
  
    // const source = this.dataSetOptions["event_logs"]
 
    // // const tech = source.technology.find(t => t.value === input.technology)?.disp;
 
    // // const device = source.devices[input.technology]
    // //   ?.find(d => d.value === input.platform_id)?.disp;
  
    // const dataset = source.data_set[input.platform_id]
    //   ?.find(d => d.value === input.data_set)?.disp;
  
    // return dataset;

    let input =this.dataSet
  
    const source = this.dataSetOptions[this.widgetType.value]
 
    // const tech = source.technology.find(t => t.value === input.technology)?.disp;
 
    // const device = source.devices[input.technology]
    //   ?.find(d => d.value === input.platform_id)?.disp;

//console.log(source,"/n",input)

    let dataset

    if(this.widgetType.value == 'Event_Logs'){
      dataset = source.data_set[input.platform_id]
      ?.find(d => d.value === input.data_set)?.disp;
    }else{
      dataset = source.data_set[input.technology]
      ?.find(d => d.value === input.data_set)?.disp;
    }
  
   
  
    return dataset;
  }

  
  // getDisplayString() {
  //   // const input = { technology: 'Firewall', platform_id: 22, data_set: 2 };

  //   let input =this.dataSet
  
  //   const source = this.dataSetOptions
 
  //   const tech = source?.technology?.find(t => t.value === input.technology)?.disp;
 
  //   const device = source.devices[input.technology]
  //     ?.find(d => d.value === input.platform_id)?.disp;
  
  //   const dataset = source.data_set[input.platform_id]
  //     ?.find(d => d.value === input.data_set)?.disp;
  
  //   return [tech, device, dataset].filter(Boolean).join('  ');
  // }

  selectionForm = new FormGroup({
    technology: new FormControl(null,Validators.required),
    platform_id: new FormControl(null,Validators.required),
    data_set: new FormControl(null,Validators.required),
  });

  changeChartState(){
//console.log("Change Chart")
//console.log(this.dataSetFields)
    this.ListOfCharts.forEach(val=>{
      val.options.forEach(chart=>{
        if(this.dataSetFields.no_of_dimensions >= chart.requirements.minDimensions){
          chart.enable=true
        }else{
          chart.enable=false
        }
      })
    })
//console.log(this.ListOfCharts)
  }

  getLimitBy(){
    let arr=[]
    this.setupForm.get('setup').get('metrics').get('metric_fields').value.forEach(met=>{
      // arr.push({"disp": this.metricFunctions.find(val => val.value == met.function)?.disp +" "+ this.metricsAndDimensions.find(val => val.value == met.field)?.disp ,"value":met.function+" "+met.field})
      arr.push({"disp": met.disp ,"value":met.function+" "+met.field})
      // this.widgetbuildervarservice.allFields.push({"disp": this.widgetbuildervarservice.metricFunctionsFiltered.find(val => val.value == met.function)?.disp +" "+ this.widgetbuildervarservice.metrics.find(val => val.value == met.field)?.disp ,"value":met.function+" "+met.field})
      // let newSet = new Set(this.widgetbuildervarservice.allFields)
      // this.widgetbuildervarservice.allFields=Array.from(newSet)
    })
    return arr
  }



  stepTabs: StepTab[] = [
    // { label: 'Select Data Set', step: 1, isActive: true , enable:true },
    { label: 'Select Chart Type', step: 2, isActive: false , enable:false}
  ];

  tableStyle={
    "table":{},
    "thead":{},
    "tbody":{},
    "trhead":{},
    "trbody":{},
    "th":{},
    "td":{}
  }

  ListOfCharts=[]

  rawData={rows:[]}

  headers=[]


  // mockTableData={
  //   headers: [
  //     { disp: 'Time', value: 'time', type: 'timestamp', category: 'dimension' },
  //     { disp: 'Src IP', value: 'src_ip', type: 'inet', category: 'dimension' },
  //     {
  //       disp: 'Country',
  //       value: 'source_country',
  //       type: 'text',
  //       category: 'dimension',
  //     },
  //     { disp: 'DST IP', value: 'dst_ip', type: 'inet', category: 'dimension' },
  //     { disp: 'Sent', value: 'sent', type: 'number', category: 'metric' },
  //     { disp: 'Recv', value: 'recv', type: 'number', category: 'metric' },
  //   ],
  //   rows: [
  //     {
  //       time: 'Oct 24, 14:22:10',
  //       src_ip: '192.168.1.45',
  //       source_country: 'United States',
  //       dst_ip: '104.18.2.12',
  //       sent: '1,240',
  //       recv: '0',
  //     },
  //     {
  //       time: 'Oct 24, 14:25:34',
  //       src_ip: '192.168.1.4',
  //       source_country: 'United States',
  //       dst_ip: '52.201.33.1',
  //       sent: '452',
  //       recv: '10,092',
  //     },
  //     {
  //       time: 'Oct 24, 14:25:34',
  //       src_ip: '172.16.0.122',
  //       source_country: 'United States',
  //       dst_ip: '174.201.33.1',
  //       sent: '10',
  //       recv: '892',
  //     },
  //     {
  //       time: 'Oct 24, 14:25:34',
  //       src_ip: '172.16.0.22',
  //       source_country: 'Germany',
  //       dst_ip: '204.18.2.12',
  //       sent: '234',
  //       recv: '15,892',
  //     },
  //   ],
  // };

  mockTableData={
    headers: [],
    rows: []
  }

  chartTypeData=[
    {
      "disp":"Bar",
      "value":"bar_chart"
    },
    {
      "disp":"Line",
      "value":"line_chart"
    },
    {
      "disp":"Area",
      "value":"area_chart"
    },
    {
      "disp":"Pie",
      "value":"pie_chart"
    }
  ]

  // chartOptions={
  //   "line": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [{ "type": "line", "data": [] }]
  //   },
  //   "bar": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [{ "type": "bar", "data": [] }]
  //   },
  //   "area": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [{ "type": "line", "areaStyle": {}, "data": [] }]
  //   },
  //   "pie": {
  //     "series": [
  //       {
  //         "type": "pie",
  //         "radius": "70%",
  //         "data": []
  //       }
  //     ]
  //   },
  //   "donut": {
  //     "series": [
  //       {
  //         "type": "pie",
  //         "radius": ["40%", "70%"],
  //         "data": []
  //       }
  //     ]
  //   },
  //   "line_stack": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [
  //       { "type": "line", "stack": "total", "data": [] }
  //     ]
  //   },
  //   "bar_stack": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [
  //       { "type": "bar", "stack": "total", "data": [] }
  //     ]
  //   },
  //   "area_stack": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "value" },
  //     "series": [
  //       {
  //         "type": "line",
  //         "stack": "total",
  //         "areaStyle": {},
  //         "data": []
  //       }
  //     ]
  //   },
  //   "heatmap": {
  //     "xAxis": { "type": "category", "data": [] },
  //     "yAxis": { "type": "category", "data": [] },
  //     "visualMap": { "min": 0, "max": 100 },
  //     "series": [{ "type": "heatmap", "data": [] }]
  //   },
  //   "polar_heat": {
  //     "polar": {},
  //     "angleAxis": { "type": "category", "data": [] },
  //     "radiusAxis": { "type": "category", "data": [] },
  //     "series": [{ "type": "heatmap", "coordinateSystem": "polar", "data": [] }]
  //   },
  //   "polar_tangential_bar": {
  //     "polar": {},
  //     "angleAxis": { "type": "category", "data": [] },
  //     "radiusAxis": {},
  //     "series": [{ "type": "bar", "coordinateSystem": "polar", "data": [] }]
  //   },
  //   "polar_radial_bar": {
  //     "polar": {},
  //     "angleAxis": {},
  //     "radiusAxis": { "type": "category", "data": [] },
  //     "series": [{ "type": "bar", "coordinateSystem": "polar", "data": [] }]
  //   },
  //   "gauge_bar": {
  //     "series": [
  //       {
  //         "type": "gauge",
  //         "progress": { "show": true },
  //         "detail": { "valueAnimation": true },
  //         "data": [{ "value": 0 }]
  //       }
  //     ]
  //   },
  //   "sankey": {
  //     "series": [
  //       {
  //         "type": "sankey",
  //         "data": [],
  //         "links": []
  //       }
  //     ]
  //   },
  //   "treemap": {
  //     "series": [
  //       {
  //         "type": "treemap",
  //         "data": []
  //       }
  //     ]
  //   }
  // }

  chartOptions= {
    "line_chart": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "value" },
      "series": [{ "type": "line", "data": [] }]
    },
  
    "bar_chart": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "value" },
      "series": [{ "type": "bar", "data": [] }]
    },
  
    // ── HORIZONTAL BAR ─────────────────────────────────────
    "horizontal_bar": {
      "xAxis": { "type": "value" },
      "yAxis": { "type": "category", "data": [] },
      "series": [{ "type": "bar", "data": [] }]
    },
  
    "area_chart": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "value" },
      "series": [{ "type": "line", "areaStyle": {}, "data": [] }]
    },
  
    "pie": {
      "series": [
        {
          "type": "pie",
          "radius": "70%",
          "data": []
        }
      ]
    },
  
    "donut": {
      "series": [
        {
          "type": "pie",
          "radius": ["30%", "70%"],
          "data": []
        }
      ]
    },
  
    // ── NIGHTINGALE ────────────────────────────────────────
    "nightingale": {
      "series": [
        {
          "type": "pie",
          "roseType": "area",
          "radius": ["20%", "75%"],
          "data": []
        }
      ]
    },
  
    "line_stack": {
      "xAxis": { "type": "category", "data": [],"boundaryGap":false ,"axisPointer": {
        "show": true,
        "status": "hide",
        "value": 9
    } },
      "yAxis": { "type": "value" ,"axisPointer": {
        "show": true,
        "status": "hide",
        "value": 9
    }},
      "series": [
        { "type": "line", "stack": "total", "data": [] }
      ]
    },
  
    "bar_stack": {
      "xAxis": { "type": "category", "data": [],"boundaryGap":true ,},
      "series": [
        { "type": "bar", "stack": "total", "data": [] }
      ]
    },
  
    "area_stack": {
      "xAxis": { "type": "category", "data": [],"boundaryGap":false ,
      "axisPointer": {
        "show": true,
        "status": "hide",
        "value": 9
    }
  },
      "yAxis": { "type": "value" ,"axisPointer": {
        "show": true,
        "status": "hide",
        "value": 9
    }},
      "series": [
        {
          "type": "line",
          "stack": "total",
          "areaStyle": {},
          "data": []
        }
      ]
    },
  
    "heatmap": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "category", "data": [] },
      "visualMap": { "min": 0, "max": 100 },
      "series": [{ "type": "heatmap", "data": [] }]
    },
  
    "polar_heatmap": {
      "polar": {},
      "angleAxis": { "type": "category", "data": [] },
      "radiusAxis": { "type": "category", "data": [] },
      "series": [{ "type": "heatmap", "coordinateSystem": "polar", "data": [] }]
    },
  
    "polar_radial_bar": {
      "polar": {},
      "angleAxis": { "type": "category", "data": [] },
      "radiusAxis": {},
      "series": [{ "type": "bar", "coordinateSystem": "polar", "data": [] }]
    },
  
    "polar_tangential_bar": {
      "polar": {},
      "angleAxis": {},
      "radiusAxis": { "type": "category", "data": [] },
      "series": [{ "type": "bar", "coordinateSystem": "polar", "data": [] }]
    },
  
    "guard_guage": {
      "series": [
        {
          "type": "gauge",
          "progress": { "show": true },
          "detail": { "valueAnimation": true },
          "data": [{ "value": 0 }]
        }
      ]
    },
  
    "sankey": {
      "series": [
        {
          "type": "sankey",
          "data": [],
          "links": []
        }
      ]
    },
  
    "treemap": {
      "series": [
        {
          "type": "treemap",
          "data": []
        }
      ]
    },

    "line_bar": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "value" },
      "series": [
        {
          "type": "line",
          "stack": "total",
          "areaStyle": {},
          "data": []
        },
        {
          "type": "bar",
          "stack": "total",
          "areaStyle": {},
          "data": []
        }
      ]
    },
    "custom_line": {
      "xAxis": { "type": "category", "data": [] },
      "yAxis": { "type": "value" },
      "series": [
        {
          "type": "line",
          "stack": "total",
          "areaStyle": {},
          "data": []
        },
        {
          "type": "line",
          "stack": "total",
          "areaStyle": {},
          "data": []
        }
      ]
    },
  }

  panelState$: BehaviorSubject<PanelState> = new BehaviorSubject<PanelState>({
    isExpanded: false
  });

  refreshChart$ = new BehaviorSubject({});

  refreshChart(value){
    this.refreshChart$.next(value);
  }

  selectedChart

  chartType=''
  chartData=[]

  getPanelState(): Observable<PanelState> {
    return this.panelState$.asObservable();
  }

  updatePanelState(state: PanelState): void {
    this.panelState$.next(state);
  }


  transformToEChartsOption(data: any) {
    const headers = data.headers;
    const rows = data.rows;
  
    // Find dimension & metrics
    const dimension = headers.find((h: any) => h.category === 'dimension');
    const metrics = headers.filter((h: any) => h.category === 'metric');
  
    if (!dimension || !metrics.length) {
      throw new Error('Need at least 1 dimension and 1 metric');
    }
  
    // X-axis
    const xAxisData = rows.map((row: any) => row[dimension.value]);
  
    // Series
    const series = metrics.map((metric: any) => ({
      name: metric.disp,
      type: 'bar',
      data: rows.map((row: any) =>
        Number(String(row[metric.value]).replace(/,/g, '')) || 0
      ),
    }));
  
    return {
      tooltip: { trigger: 'axis' },
      legend: { data: metrics.map((m: any) => m.disp) },
      xAxis: {
        type: 'category',
        data: xAxisData,
      },
      yAxis: { type: 'value' },
      series,
    };
  }

  

  commondata = this.sharedService.metaData.commonData;
  wb_meta = this.sharedService.metaData.studio.widget_builder;

  widget_mode_info = {
    label: this.wb_meta.widget_mode.default_disp
  }

  editdetails = {
    editwidget: false,
    widgetId: "",
  }

  platformList = [...this.commondata.platformOptions.platformList];
  platformMap = this.sharedService.platformMap;
  selectedPlatform = this.commondata.platformOptions.default;
  platformfields = [...this.sharedService.commonPlatformFields];
  eventFieldOptions = this.processplatformFields(this.platformfields);
  widgetname = new FormControl("", {
    validators: [Validators.maxLength(45)],
    asyncValidators: [WidgetnameValidator.createValidator(this.widgetbuilderservice,this)]

    // updateOn:'blur'
  });
  widget_mode: string = this.wb_meta.widget_mode.default_value;

  // moduleName="studio"
  moduleName=JSON.parse(JSON.stringify(this.sharedService.metaData.studio.widget_builder.moduleName))

  overLayRef: any;
  graphPropoverlayRef: any;
  pannelexpanded: boolean = true;
  toppannelexpanded: boolean = true;
  dimensionarr: any[] = [];
  selectedgraph: string = "";
  selecteddimension: number = 0;
  graphList: string[] = [];
  widgetoptions = null;
  timeFilteroption: number[] = [...this.wb_meta.wdigetpannel.timeduration.options];
  timewindowoptions: string[] = [...this.wb_meta.wdigetpannel.timewindow.options];
  selectedDays: number = this.wb_meta.wdigetpannel.timeduration.default;
  selectedwindow: string = this.wb_meta.wdigetpannel.timewindow.default;
  windowselected = new FormControl(this.wb_meta.wdigetpannel.timewindow.selected);
  chartdata = [];
  chartProp = {
    options: [],
    default: true,
    first_dimension: "",
    second_dimension: "",
    title: "",
    subtitle: ""
  };

  img_graphvalue = [];

  filter = new FormGroup({
    filtercondition: new FormArray([])
  });


  dataSet={"technology":"","platform_id":"","data_set":""}

  dataSetFields={"no_of_dimensions":null,"no_of_metrics":null}

  
  

  getDataType(array:any){
    array = array.filter(Boolean);
    array.forEach(dat=>{
      let value=this.metricsAndDimensions.filter(val=>val.value === dat.field)
      dat["type"]=value[0].type
      // dat["disp"]=value[0].disp
    })
    return array
  }

  getDataTypeForField(field){

    let value=this.metricsAndDimensions.filter(val=>val.value === field)
    return value[0]?.type

  }

  getDispForField(field){

    let value=this.metricsAndDimensions.filter(val=>val.value === field)
    return value[0]?.disp

  }

  getLimitDataType(array:any){
// console.log(array)
    array = array.filter(Boolean);
    let value =this.metricsAndDimensions.filter(val => val.value === array[0].by.field)
//console.log(this.metricsAndDimensions)
//console.log({value})
// console.log(array)
    array[0].by["type"] = value[0]?.type
    return array
  }


  // get filtercondition() {
  //   return this.filter.get('filtercondition') as FormArray;
  // }

  async getChartList() {
    await this.widgetbuilderservice.getChartList()
      .toPromise()
      .then((chartlist: any) => {
        this.graphList = [...chartlist.chartList]
      })
  }


  widgetLabelSet(widget_mode: string) {
    if (widget_mode == "alerts") {
      this.widget_mode_info.label = this.wb_meta.widget_mode.options[1].disp;
    } else {
      this.widget_mode_info.label = this.wb_meta.widget_mode.options[0].disp;
    }
  }


  processplatformFields(platformFields: any[]) {
    const arr = [];
    for (let i = 0; i < platformFields.length; i++) {
      arr.push({
        disp: platformFields[i].disp,
        value: {
          field: platformFields[i].disp,
          type: platformFields[i].type,
          display_type: platformFields[i].display_type
        }
      })
    }
    return arr;
  }

  addconditionSet(defaultTimeRange? :any) {
    if (this.filtercondition.controls.length < 3) {
      const conditionLinedefault = true;
      const conditionset = new FormGroup({
        operationconditionLine: new FormControl(conditionLinedefault),
        includeNot: new FormControl(false),
        conditionLines: new FormArray([
          this.addCondition()
        ]),
        operationConditionset: new FormControl(''),
        notOperator : new FormControl()
      })
      this.filtercondition.push(conditionset);
      if (this.filtercondition.length > 1) {
        this.filtercondition.controls[this.filtercondition.length - 2].get('operationConditionset').setValue('AND');
      }
    }
  }

  toTimeValidator(control: AbstractControl): ValidationErrors | null {

    if (!control.parent) {
      return null;
    }
  
    const fromTime = control.parent.get('fromDate')?.value;
    const toTime = control.value;
  
    if (!fromTime || !toTime) {
      return null;
    }
  
    const [fromHour, fromMin] = fromTime.split(':').map(Number);
    const [toHour, toMin] = toTime.split(':').map(Number);
  
    const fromTotal = (fromHour * 60) + fromMin;
    const toTotal = (toHour * 60) + toMin;
  
    return toTotal > fromTotal
      ? null
      : { invalidToDate: true };
  }

  fromTimeValidator(control: AbstractControl): ValidationErrors | null {

    if (!control.parent) {
      return null;
    }
  
    const fromTime = control.value;
    const toTime = control.parent.get('toDate')?.value;
  
    if (!fromTime || !toTime) {
      return null;
    }
  
    const [fromHour, fromMin] = fromTime.split(':').map(Number);
    const [toHour, toMin] = toTime.split(':').map(Number);
  
    const fromTotal = (fromHour * 60) + fromMin;
    const toTotal = (toHour * 60) + toMin;
  
    return fromTotal < toTotal
      ? null
      : { invalidFromDate: true };
  }

  addCondition(defaultTime? :any) {

    let group = new FormGroup({
      eventField: new FormControl(),
      fromDate : new FormControl('',this.fromTimeValidator),
      operator: new FormControl(this.wb_meta.wdigetpannel.filter_condition.default),
      toDate : new FormControl('',this.toTimeValidator),
      conditionValue: new FormArray([]),
      conditionInput: new FormControl(''),
      includeNot : new FormControl(false)
    }, {
      validators: [ValueValidator()]
    })

    group.get('fromDate').valueChanges.subscribe(val=>{
      group.get('toDate').updateValueAndValidity({emitEvent:false})
    })
    group.get('toDate').valueChanges.subscribe(val=>{
      group.get('fromDate').updateValueAndValidity({emitEvent:false})
    })
    return group
  }

  addfirstset = this.addconditionSet();

  conditionLinearr(setindex: number) {
    return this.filtercondition.at(setindex).get("conditionLines") as FormArray;
  }

  // conditionvalue(setindex: number, lineindex: number) {
  //   return this.conditionLinearr(setindex).at(lineindex).get("conditionValue") as FormArray;
  // }

  // extendfilterConditions(filter: any[]) {
  //   filter.forEach((setelement: any, setindex: number) => {
  //     if (setindex) {
  //       this.addconditionSet();
  //     }
  //     setelement.conditionLines.forEach((lineElement: any, lineindex: number) => {
  //       if (lineindex) {
  //         this.conditionLinearr(setindex).push(this.addCondition());
  //       }
  //       lineElement.conditionValue.forEach((condval: any) => {
  //         this.conditionvalue(setindex, lineindex).push(new FormControl(condval));
  //       })
  //     })
  //   });
  //   this.filtercondition.patchValue(filter);
  // }

  reset_default_values() {
    this.selectedPlatform = this.commondata.platformOptions.default;
    this.platformfields = this.sharedService.commonPlatformFields;
    this.eventFieldOptions = this.processplatformFields(this.platformfields);
    this.widgetname.setValue("", { emitEvent: false });
    this.widget_mode = this.wb_meta.widget_mode.default_value;
    this.widget_mode_info.label = this.wb_meta.widget_mode.default_disp;
  }

  processEdit(widgetdetails: any) {
    this.dimensionarr = [...widgetdetails.display_dimension];
    this.selectedgraph = widgetdetails.chart_type;
    this.selectedPlatform = widgetdetails.dimensions;
    this.selectedDays = widgetdetails.duration;
    this.selectedPlatform = widgetdetails.platform;
    this.chartProp.first_dimension = widgetdetails.first_dimension;
    this.chartProp.second_dimension = widgetdetails.second_dimension;
    this.chartProp.default = false;
    this.chartProp.title = widgetdetails.title;
    this.chartProp.subtitle = widgetdetails.sub_title;
    this.widgetname.setValue(widgetdetails.widget_name);
    this.selectedwindow = widgetdetails.time_window.window;
    this.windowselected.setValue(widgetdetails.time_window.selected, { emitEvent: false });
    // this.extendfilterConditions(widgetdetails.display_filter);
    this.editdetails.editwidget = true;
    this.editdetails.widgetId = widgetdetails.widget_id;
    this.toppannelexpanded = true;
    this.widgetname.disable({ emitEvent: false });
  }

  assignChartData(chartlist: any) {
    this.graphList = [...chartlist.chartList];
    this.img_graphvalue = chartlist.chartList.filter((element: any) => {
      if (element.widget_img) {
        return element;
      }
    })
  }

  assignFieldsDetails(platform_fields: any[], platform: any, widget_mode: any) {
    this.selectedPlatform = platform;
    this.widget_mode = widget_mode;
    this.widgetLabelSet(widget_mode);
    this.platformfields = platform_fields;
    this.eventFieldOptions = this.processplatformFields(this.platformfields);
  }

  processWidgetAddOrEdit(platform: any, widget_mode: any) {
    return new Promise((resolve, reject) => {
      this.widgetbuilderservice.getChartList().toPromise()
        .then((chartlist: any) => {
          if (platform !== this.selectedPlatform || widget_mode !== this.widget_mode) {
            if (widget_mode == "events") {
              this.userloginservice.getCommonFields({ platform: platform }).toPromise()
                .then((fields: any) => {
                  this.assignChartData(chartlist);
                  this.assignFieldsDetails(fields.platform_fields, platform, widget_mode);
                  resolve(null);
                })
                .catch((err) => {
                  reject(null);
                })
            } else {
              this.widgetbuilderservice.getAlertFields({ platform: platform }).toPromise()
                .then((fields: any) => {
                  this.assignChartData(chartlist);
                  this.assignFieldsDetails(fields.alert_fields, platform, widget_mode);
                  resolve(null);
                })
                .catch((err) => {
                  reject(null);
                })
            }
          } else {
            this.assignChartData(chartlist);
            resolve(null);
          }
        })
        .catch((err) => {
          reject(null);
        })
    })
  }

  format_axiz_lable(option) {
    let temp_option = {}
    if ('yAxis' in option && 'type' in option['yAxis'] && option['yAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'yAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            }
          }
        }
      }
      return temp_option
    }
    else if ('angleAxis' in option && 'type' in option['angleAxis'] && option['angleAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'angleAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            },
            'axisLine': {
              'lineStyle': {
                'opacity': 0.2
              }
            }
          }
        }
      }
      return temp_option;
    }
    else if ('xAxis' in option && 'type' in option['xAxis'] && option['xAxis']['type'] == 'value') {
      temp_option = {
        ...option, ...{
          'xAxis': {
            'axisLabel': {
              'formatter': function (value) {
                if (value >= 1000000000) {
                  return echarts.format.addCommas((value / 1000000000).toFixed(1)) + ' B';
                } else if (value >= 1000000) {
                  return echarts.format.addCommas((value / 1000000).toFixed(1)) + ' M';
                } else if (value >= 1000) {
                  return echarts.format.addCommas((value / 1000).toFixed(1)) + ' K';
                } else {
                  return echarts.format.addCommas(value);
                }

              }
            }
          }
        }
      }
      return temp_option;
    }
    else return option;
  }
}
